// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__LOk0m","Logo":"Navigation_Logo__2Y1_5","NavList":"Navigation_NavList__3UFHT"};